import createAlert from "../../../../../scripts/alert/createAlert"
import { setAlert } from "../../../../../store/reducers/alert/alertReducer"
import { RequestResponsePattern } from "../../../../../types/Request"
import { getApi, postApi } from "../../../../../utils/requestApi"
import { DOMAIN } from "../../../../../var_env."

export default async function saveConfig(data: any, dispatch: Function) {
    try {


        const endpoint = `${DOMAIN}/configuracaoapp/save`

        const response: RequestResponsePattern<string[]> = await postApi({ endpoint, data })

        if (response) {

            if (!response.flagErro) {
                dispatch(setAlert(createAlert('success', 'Configuração salva com  sucesso')))
                return response.listaResultados

            } else throw new Error(response.listaMensagens[0])
        } else throw new Error('Erro na requisição')
    } catch (error: any) {
        dispatch(setAlert(createAlert('error', error.message)))
        return []

    }
}